export const FetchUserDataInSettings = async () => {
  try {
    const response = await fetch("/api/mock/Settings/UserMockData-settings.json");
    const data = await response.json();

    if (!data) {
      console.warn("No user data found.");
      return null;
    }

    return {
      userId: data.userId || "",
      name: {
        firstName: data.name?.firstName || "",
        lastName: data.name?.lastName || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      ethenic: data.ethenic || "",
      email: data.email || "",
      password: data.password || "",
      mobileNumber: data.mobileNumber || "",
      devices: data.devices || [],
      dateOfBirth: data.dateOfBirth || "",
      address: {
        street: data.address?.street || "",
        city: data.address?.city || "",
        state: data.address?.state || "",
        zipCode: data.address?.zipCode || "",
        country: data.address?.country || ""
      },
      consent: {
        termsAccepted: data.consent?.termsAccepted ?? true,
        emailMarketing: data.consent?.emailMarketing ?? false,
        analyticsTracking: data.consent?.analyticsTracking ?? true
      },
      payAccounts: {
        paypal: data.payAccounts?.paypal || "",
        stripe: data.payAccounts?.stripe || ""
      },
      nProfCount: data.nProfCount || 0,
      profiles: Array.isArray(data.profiles)
        ? data.profiles.map((p) => ({
            profilename: p.profilename || "",
            profileimage: p.profileimage || "",
            theme: p.profiletheme || "",
            mediaDisplayMode: p.mediaDisplayMode || ""
          }))
        : []
    };
  } catch (error) {
    console.error("Failed to fetch user with profiles data:", error);
    return null;
  }
};
